import { render, staticRenderFns } from "./InspectorLocalization.vue?vue&type=template&id=14a033d2&"
import script from "./InspectorLocalization.vue?vue&type=script&lang=js&"
export * from "./InspectorLocalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports